export default __webpack_public_path__ + "static/media/white_unlocked_lock.a7bc9d61.svg";